import React from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { Text } from '@perch-labs/shrike';
import { GET_STRIPE_PAYMENT_LINK } from './pay-balance.api';

export const PayBalance = () => {
  const { planId } = useParams<{ planId?: string }>();

  const { data, loading, error } = useQuery(GET_STRIPE_PAYMENT_LINK, {
    variables: { planId: Number(planId) },
  });

  if (loading) return <Text>Loading...</Text>;
  if (error) return <Text>Error loading payment link.</Text>;

  const paymentLink = data?.plan?.paymentLink?.stripeCheckoutUrl;

  if (paymentLink) {
    window.location.replace(paymentLink);
    return null;
  }
  return <Text>Invalid payment link.</Text>;
};
